import React, {PureComponent, ReactNode} from "react";

export type GarageProfilePickupServiceProps = {
};

export class GarageProfilePickupService extends PureComponent<GarageProfilePickupServiceProps> {

    render(): ReactNode {

        return (
            <div className={'col-span-full mb-6 md:mb-8'}>
                <h3 className={'text-base leading-6 md:text-xl md:leading-7 font-semibold font-serif text-gray-900 mb-4'}>Hol- & Bringservice der Werkstatt</h3>
                <p className={'text-base leading-6 font-normal text-gray-900'}>Die Werkstatt holt dein Auto bei dir ab. Wenn sie fertig mit deinem Auto ist, bringt sie es dir wieder zurück.</p>
                <p className={'text-base leading-6 font-normal text-gray-900 italic'}>Kann unter Komfortservice hinzugefüg werden. Bitte wähle dafür zuerst einen Service aus.</p>
            </div>
        )
    }
}